/* Horizontal product carousel: arrow paging + arrow state, matching the reference's
   scroll-with-edge-arrows behaviour. Native scroll stays available for touch/trackpad. */
(function () {
  function setup(root) {
    if (root.dataset.blCarReady === '1') return;
    root.dataset.blCarReady = '1';

    var track = root.querySelector('[data-bl-car-track]');
    var prev = root.querySelector('[data-bl-car-prev]');
    var next = root.querySelector('[data-bl-car-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.bl-card');
      if (!card) return track.clientWidth;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var cardW = card.getBoundingClientRect().width + gap;
      // advance by whole cards, never past the viewport width
      var perView = Math.max(1, Math.floor(track.clientWidth / cardW));
      return cardW * perView;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      // centre the arrows on the card image rather than the whole card
      var media = track.querySelector('.bl-card__media');
      if (media) {
        var h = media.getBoundingClientRect().height;
        if (h) root.style.setProperty('--bl-car-nav-top', Math.round(h / 2) + 'px');
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);

    sync();
    // images settle after load and change the media height
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', sync, { once: true });
    });
  }

  function init() { document.querySelectorAll('[data-bl-carousel]').forEach(setup); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
